import PropTypes from 'prop-types';

import {Tooltip} from '@chakra-ui/react';

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui';

/**
 * Tooltip for markup parsed via jsxParser (see king-living RAW_COMPONENTS):
 * `<div role="option-tooltip">…</div>` or `<div class="tooltip-amb">…</div>`.
 * Inner HTML becomes the tooltip label; a question-mark-in-circle icon is the trigger.
 */
export function TooltipAmb({children, className = '', role, ...rest}) {
  if (children == null || children === false) {
    return null;
  }

  return (
    <Tooltip
      label={children}
      openDelay={200}
      placement="top"
      hasArrow
      shouldWrapChildren
      {...rest}
    >
      <Box
        aria-label="More information"
        as="span"
        className={className}
        cursor="help"
        display="inline-flex"
        flexShrink={0}
        alignItems="center"
        justifyContent="center"
        h="17px"
        minH="20px"
        minW="20px"
        role="img"
        w="17px"
      >
        <svg fill="none" height="17" viewBox="0 0 17 17" width="17" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.25 6.24962C6.25007 5.88297 6.35093 5.5234 6.54155 5.2102C6.73217 4.897 7.00522 4.64222 7.33085 4.47372C7.65649 4.30522 8.02218 4.22947 8.38795 4.25476C8.75373 4.28005 9.10551 4.40541 9.40486 4.61712C9.7042 4.82883 9.93959 5.11876 10.0853 5.45521C10.231 5.79167 10.2814 6.1617 10.231 6.52487C10.1806 6.88804 10.0314 7.23036 9.79958 7.51444C9.56778 7.79851 9.26235 8.0134 8.91667 8.13562C8.72161 8.20458 8.55275 8.33234 8.43335 8.50129C8.31395 8.67024 8.24989 8.87207 8.25 9.07895V9.74962"
            stroke="#A67C4A"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M8.25 11.25C8.05222 11.25 7.85888 11.3086 7.69443 11.4185C7.52998 11.5284 7.40181 11.6846 7.32612 11.8673C7.25043 12.05 7.23063 12.2511 7.26922 12.4451C7.3078 12.6391 7.40304 12.8173 7.54289 12.9571C7.68274 13.097 7.86093 13.1922 8.05491 13.2308C8.24889 13.2694 8.44996 13.2496 8.63268 13.1739C8.81541 13.0982 8.97159 12.97 9.08147 12.8056C9.19135 12.6411 9.25 12.4478 9.25 12.25C9.25 11.9848 9.14464 11.7304 8.95711 11.5429C8.76957 11.3554 8.51522 11.25 8.25 11.25Z"
            fill="#A67C4A"
          />
          <path
            d="M8.25 15.75C12.3921 15.75 15.75 12.3921 15.75 8.25C15.75 4.10786 12.3921 0.75 8.25 0.75C4.10786 0.75 0.75 4.10786 0.75 8.25C0.75 12.3921 4.10786 15.75 8.25 15.75Z"
            stroke="#A67C4A"
            strokeMiterlimit={10}
            strokeWidth="1.5"
          />
        </svg>
      </Box>
    </Tooltip>
  );
}

TooltipAmb.displayName = 'TooltipAmb';
TooltipAmb.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  role: PropTypes.string,
};
